/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    &.bg {
      fill: #294b72;
    }
    &.line {
      fill: #6184AC;
    }
    &.txt {
      fill: #eee;
    }
  }
`

export default class SharedBetIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="16.499" height="10.918" viewBox="0 0 16.499 10.918" css={Color} className="shared-bet-ico">
        <g id="그룹_5578" data-name="그룹 5578" transform="translate(-555.776 -1219.648)">
          <g id="그룹_5577" data-name="그룹 5577">
            <path id="빼기_37" className="bg" data-name="빼기 37" d="M571.026,1230.317h-14a1,1,0,0,1-1-1V1220.9a1,1,0,0,1,1-1h14a1,1,0,0,1,1,1h0v2.033a2.286,2.286,0,0,0,0,4.351v2.034a1,1,0,0,1-1,1Z" fill="#294b72"/>
            <path id="패스_5368" className="line" data-name="패스 5368" d="M571.025,1230.566h-14a1.25,1.25,0,0,1-1.25-1.25V1220.9a1.251,1.251,0,0,1,1.25-1.25h14a1.251,1.251,0,0,1,1.25,1.25v2.215l-.172.057a2.036,2.036,0,0,0,0,3.875l.172.057v2.214A1.25,1.25,0,0,1,571.025,1230.566Zm-14-10.418a.751.751,0,0,0-.75.75v8.418a.751.751,0,0,0,.75.75h14a.752.752,0,0,0,.75-.75v-1.858a2.536,2.536,0,0,1,0-4.7V1220.9a.752.752,0,0,0-.75-.75Z" fill="#6184ac"/>
          </g>
          <path id="패스_5367-2" className="txt" data-name="패스 5367-2" d="M559,1227.229l1.469-.012c.907-.008,1.6-.4,1.607-1.238a.924.924,0,0,0-.765-.977v-.028a.963.963,0,0,0,.57-.9c.006-.779-.637-1.021-1.481-1.014l-1.365.011Zm.844-2.473.009-1.057h.49c.5,0,.739.14.736.505,0,.332-.233.547-.756.551Zm-.015,1.826.01-1.208h.573c.568,0,.867.161.863.566,0,.433-.311.638-.873.642Zm2.961.616,2.588-.022.006-.7-1.764.015.009-1.113,1.447-.012.006-.7-1.448.021.008-.963,1.7-.014.009-.692-2.527.021Zm4.24-.036.824-.007.029-3.468,1.169-.01.005-.69-3.15.027-.007.691,1.159-.01Z" fill="#eee"/>
        </g>
      </svg>

    )
  }
}
